import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Row, Col } from 'flexbox'

import { Field, reduxForm } from 'redux-form'

import { InputForm } from 'controls/Input'
import { DropDownForm } from 'controls/DropDown'
import Button from 'controls/Button'

import { required } from 'services/validators'

import { reasons, texts } from '../calendarConfig'
import styles, { classNames } from './styles'

class ActionModal extends PureComponent {
  static propTypes = {
    appointmentType: PropTypes.oneOf(['VALUATION', 'SHOW', 'CUSTOM_EVENT'])
      .isRequired,
    reasonType: PropTypes.oneOf(['FAILURE', 'CANCELLED']).isRequired,
    cancelEvent: PropTypes.func.isRequired,
    deleteEvent: PropTypes.func.isRequired
  }

  submit = ({ comments, reason: { value } }) =>
    this.props.cancelEvent({
      cancellationComment: comments,
      reason: value
    })

  renderConfirm = () => (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>¿Esta seguro que desea borrar el evento?</h1>
      <Row>
        <Col xs={6} sm={4} smOffset={1}>
          <Button
            color="primary"
            fullWidth
            outline
            onClick={this.props.closeModal}
          >
            Cancelar
          </Button>
        </Col>
        <Col xs={6} sm={4} smOffset={2}>
          <Button
            color="primary"
            fullWidth
            outline
            onClick={this.props.deleteEvent}
          >
            Aceptar
          </Button>
        </Col>
      </Row>
    </div>
  )

  render() {
    const { appointmentType, reasonType, handleSubmit, invalid } = this.props

    if (appointmentType == 'CUSTOM_EVENT') {
      return this.renderConfirm()
    }

    const options = reasons
      .filter(r => r.type === `${appointmentType}_${reasonType}`)
      .map(r => ({ value: r.id, label: r.name }))
    const titles = texts[appointmentType.toLowerCase()]

    return (
      <form
        className={classNames.container}
        onSubmit={handleSubmit(this.submit)}
      >
        <Row className={classNames.header}>
          <h4 className={classNames.title}>{titles.title}</h4>
          <h5 className={classNames.description}>{titles.description}</h5>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              name="reason"
              className={classNames.inputRow}
              id="reason"
              options={options}
              component={DropDownForm}
              placeholder="¿Por que motivo se cancelará la cita?"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              name="comments"
              className={classNames.inputRow}
              id="comments"
              component={InputForm}
              placeholder="Información adicional"
            />
          </Col>
        </Row>
        <Row className={classNames.buttons}>
          <Col xs={12}>
            <Button color="primary" type="submit" disabled={invalid}>
              Confirmar
            </Button>
          </Col>
        </Row>
        <style jsx>{styles}</style>
      </form>
    )
  }
}

const validate = values => {
  const errors = {}
  if (!required(values.reason)) {
    errors.reason = 'La razón es requerida'
  }
  return errors
}

const formConfig = {
  form: 'appointmentCancellationModal',
  validate
}

export default reduxForm(formConfig)(ActionModal)
